import React from "react";

const Java_DataTypes_Example = () => {
  return (
    <div>
      <h1>Java DataTypes Example</h1>
      <p>This page provides explanations, examples, and common use-cases for Java DataTypes Example in Java.</p>
    </div>
  );
};

export default Java_DataTypes_Example;
